exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".eurus-banner-background{background:url(" + require("../assets/orangeroom.jpg") + ") no-repeat;height:130px;background-position:top}.eurus-motto{position:relative;top:-100px;left:200px;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-30e19474","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Banner.vue
// module id = 28
// module chunks = 11